module.exports = __webpack_public_path__ + "static/scale-model-of-mcconnell-springs-in-lexington-kentucky-362af19feece998d4bcb8d90039e802a.png";